import React from 'react';
import { useParams } from 'react-router-dom';

const ToDocumentUploadPortalContractHash = () => {
  
  const { hash } = useParams();
  const baseUrl = process.env.REACT_APP_DOCUMENT_UPLOAD_PORTAL_URL;
  const redirectUrl = `${baseUrl}/contracts/${hash}`;
  window.location.replace(redirectUrl);

  return null;
};

export default ToDocumentUploadPortalContractHash;